import { Box, Flex, Modal, ModalOverlay, ModalContent, ModalFooter, ModalHeader, ModalBody } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { Cross, Stars } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { Divider } from 'uiToolkitV1/Divider';
import { TextBodyMedium, TextHeader2 } from 'uiToolkitV1/Typography';

import { goalPreferencesActions, useGoalPreferencesContext } from '../context/GoalPreferencesProvider';

const primaryDrawerWidth = '578px';
const secondaryDrawerWidth = 1134;

const ConfirmationModal = ({ isSecondaryPanelOpen = false, children }) => {
  const { state, goalPreferenceDispatch, saveChanges } = useGoalPreferencesContext();

  const { isOpen, text, onSuccess, heading } = state.modal;

  const closeModal = () => {
    goalPreferenceDispatch({
      type: goalPreferencesActions.UPDATE_CONFIRMATION_MODAL,
      payload: {
        isOpen: false,
        text: '',
        heading: '',
        // text: '    Are you sure you want to save these modifications to settings?',
        onSuccess: () => {},
      },
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={closeModal} isCentered>
      <ModalOverlay />
      <ModalContent position="relative" maxH="204px" maxW="578px">
        <ModalHeader position="relative">
          <Flex alignItems="center">
            <Stars boxSize="20px" />
            <Box pl={2}>
              <Flex alignItems="center" justifyContent="space-between">
                <TextHeader2 bold>{heading}</TextHeader2>
              </Flex>
            </Box>
          </Flex>
          <StyleCloseButton
            variant="filled"
            color="black"
            StartIcon={(props) => <Cross {...props} boxSize="20px" />}
            onClick={closeModal}
          />
        </ModalHeader>

        <Divider opacity={1} color="#EBEFF3" />
        <ModalBody p="25px">
          {' '}
          <Box ml={3} p={1}>
            <TextBodyMedium>{text}</TextBodyMedium>
          </Box>
        </ModalBody>

        {heading === 'Save Changes' && (
          <ModalFooter
            sx={{
              background: '#F5F7F9',
              borderTop: '1px solid #CED7DF',
              borderRadius: '0px 0px 8px 8px',
            }}
          >
            <Button sty variant="outlined" mr={4} onClick={closeModal}>
              No
            </Button>
            <Button variant="filled" colorScheme="blue" onClick={onSuccess} disabled={false}>
              Yes
            </Button>
          </ModalFooter>
        )}

        {heading === 'Delete this Template?' && (
          <ModalFooter
            sx={{
              background: '#F5F7F9',
              borderTop: '1px solid #CED7DF',
              borderRadius: '0px 0px 8px 8px',
            }}
          >
            <Button sty variant="outlined" mr={4} onClick={closeModal}>
              Cancel
            </Button>
            <Button variant="filled" colorScheme="red" onClick={onSuccess} disabled={false}>
              Delete
            </Button>
          </ModalFooter>
        )}

        {heading === 'Cancel Changes' && (
          <ModalFooter
            sx={{
              background: '#F5F7F9',
              borderTop: '1px solid #CED7DF',
              borderRadius: '0px 0px 8px 8px',
            }}
          >
            <Button sty variant="outlined" mr={4} onClick={closeModal}>
              Go Back to Preferences
            </Button>
            <Button variant="filled" colorScheme="red" onClick={onSuccess} disabled={false}>
              Exit Preferences
            </Button>
          </ModalFooter>
        )}
        {/* <Flex
            bgColor={theme.colors.surface.F5F7F9}
            alignItems={'center'}
            justifyContent={'flex-end'}
            paddingRight={4}
            position="fixed"
            bottom={0}
            width={'100%'}
            columnGap={4}
            paddingY={3}
          >
            <Button onClick={closeModal} variant="outlined">
              Cancel
            </Button>

            <Button onClick={closeModal} disabled={false}>
              Save
            </Button>
          </Flex> */}
      </ModalContent>
    </Modal>
  );
};

export default ConfirmationModal;

const StyleCloseButton = styled(Button)`
  position: absolute;
  left: -14px;
  top: -14px;

  padding: 2px;
  height: 28px;

  border-radius: 50%;
  border: 2px solid ${(props) => props.theme.colors.neutral.F5F7F9};
`;
